/**
 * GiftCardsTable — the gift-cards list table (BON-223).
 *
 * Six columns, no sorting: the frozen contract sorts `createdAt desc` and
 * operators reach a specific card by searching, not by re-ordering.
 */
import { GiftCardsTableRow } from './GiftCardsTableRow';
import type { GiftCardListRow } from './giftCardTypes';

export interface GiftCardsTableProps {
  rows: GiftCardListRow[];
}

export function GiftCardsTable({ rows }: GiftCardsTableProps) {
  return (
    <table className="nb-tbl" aria-label="Gift cards" style={{ minWidth: 760 }}>
      <thead>
        <tr>
          <th scope="col" style={{ paddingLeft: 18 }}>
            Card
          </th>
          <th scope="col">Customer</th>
          <th scope="col" style={{ textAlign: 'right' }}>
            Balance
          </th>
          <th scope="col">Status</th>
          <th scope="col">Source</th>
          <th scope="col" style={{ whiteSpace: 'nowrap', paddingRight: 18 }}>
            Created
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <GiftCardsTableRow key={row.id} row={row} />
        ))}
      </tbody>
    </table>
  );
}
